import { create } from "zustand";
import { type CalculationResult } from "@/types/calculator";

interface ResultStore {
  result: CalculationResult | null;
  isCalculating: boolean;
  setResult: (r: CalculationResult) => void;
  setIsCalculating: (v: boolean) => void;
  clearResult: () => void;
}

export const useResultStore = create<ResultStore>()((set) => ({
  result: null,
  isCalculating: false,
  setResult: (result) => set({ result }),
  setIsCalculating: (isCalculating) => set({ isCalculating }),
  clearResult: () => set({ result: null }),
}));